<div class="common-header-outer-component" id="common-header-outer-component">
    <div class="header" id="common-header">{{ header }}</div>
    <div class="subHeader" id="common-subheader" *ngIf="subHeader">
        <span class="pipe">|</span> 
        {{ subHeader }}</div>
</div>